import { useEffect, useState } from "react"
import { getFormatFecha } from "../../helpers/dates"
import PageController from "../pageController/PageController"
import './tbStyles.css'

export const TbSongs = ({ songs, updateSong, deleteSong }) => {

  const [canciones, setCanciones] = useState([])
  const [initData, setInitData] = useState(0)
  const pagesize = parseInt(process.env.REACT_APP_PAGE_RECORDS);

  useEffect(() => {
    const loadData = async () => {
      setCanciones(await songs.slice(initData, initData + pagesize));
    }
    loadData()
  }, [songs, initData, pagesize]);

  return (
    <div className="table-container">
      <table cellSpacing='0'>
        <thead>
          <tr>
            <th>ID</th>
            <th>TITULO</th>
            <th className="responsive-movil" >DURACION</th>
            <th className="responsive" >AÑO</th>
            <th>ARTISTAS</th>
            <th className="responsive">VISIBLE</th>
            <th className="responsive">FECHOR</th>
            <th colSpan={2}>ACCIONES</th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(canciones)
            ? canciones.map((song) => (             
              <tr key={song.CAN_CLAVE}>
                <td >{song.CAN_CLAVE}</td>
                <td>{song.CAN_TITULO}</td>
                <td className="responsive-movil">{song.CAN_DURACION}</td>
                <td className="responsive">{song.CAN_ANYO}</td>
                <td>{song.ART_NOMBRE}</td>
                <td className="responsive"><input type='checkbox' checked={song.CAN_VISIBLE.data[0]} disabled /></td>
                <td className="responsive">{getFormatFecha(song.CAN_FECHOR)}</td>
                <td><button
                  onClick={() => updateSong(song)}
                  className="material-icons-outlined">edit</button></td>
                <td><button
                  onClick={() => deleteSong(song)}
                  className="material-icons-outlined">delete</button></td>

              </tr>
            ))
            : <h1>NO HAY DATOS EN LA TABLA</h1>}
        </tbody>
      </table>
      <section className="tbFooter">
        <PageController initData={initData} setInitData={setInitData} length={songs.length} />
      </section>
    </div>
  )
}
